/**
 * Layout recipes for the AI brief. Picking one fixes the structure, so the
 * person only describes the content, and the same recipe gives the same
 * structure whichever AI tool or person writes the prompt.
 */
export type Recipe = { id: string; label: string; layout: string };

export const RECIPES: Recipe[] = [
  {
    id: 'image-text',
    label: 'Image and text',
    layout: 'A large image on one side and text on the other: a heading, a short paragraph and one or two pill buttons. On mobile the image sits above the text. If there are several rows, alternate the image side.'
  },
  {
    id: 'steps',
    label: 'Steps',
    layout: 'A heading, then 3 to 5 numbered steps in a row, each with a number, a short title and one sentence. On mobile the steps stack vertically.'
  },
  {
    id: 'feature-grid',
    label: 'Feature grid',
    layout: 'A heading and one intro line, then a grid of 3 to 6 features, each with a small image or icon, a title and one sentence. Three columns on desktop, two on tablet, one on mobile.'
  },
  {
    id: 'spec-table',
    label: 'Spec table',
    layout: 'A heading, then specifications as two columns (label on the left, value on the right) separated by thin silver lines, with an optional group title above each group of rows.'
  },
  {
    id: 'quote',
    label: 'Quote',
    layout: 'One large quotation in the center, with the person’s name and title below it, on a paper or night background.'
  },
  {
    id: 'cta',
    label: 'Call to action',
    layout: 'A short heading, one sentence and one or two pill buttons, centered, on a night background with white text.'
  }
];

export const findRecipe = (id?: string | null): Recipe | undefined => RECIPES.find(r => r.id === id);
